export function textIncludes(text, value) {
    return text.toLowerCase().includes(value.toLowerCase());
}
